import {getValidations} from "./validations";

export const checkPath = (query) => {
    const record = getValidations(query);
    const pageUrlArray = window.location.pathname.split('/');
    if (pageUrlArray && pageUrlArray[1]) {
        if (pageUrlArray[1].startsWith('ipinfo')) {
            if (record.ip) {
                window.location.href = `\\ipinfo\\${query}`;
                return
            }
        }
        if (pageUrlArray[1].startsWith('email-checker')) {
            if (record.email) {
                window.location.href = `\\email-checker\\${query}`;
                return
            }
        }
        if (pageUrlArray[1].startsWith('uptime-monitoring')) {
            if (record.domain || record.ip) {
                window.location.href = `\\uptime-monitoring?url=${query}`;
                return
            }
        }
        if (pageUrlArray[1].startsWith('website-malware-scanner')) {
            if (record.domain || record.ip) {
                window.location.href = `\\website-malware-scanner?url=${query}`;
                return
            }
        }
    }
    window.location.href = `\\blacklists\\${query}`;
}
